<template>
  <div v-if="input.conditionalRender">
    <div v-if="input.conditionalRender && providesCondition">
      <slot />
    </div>
    <!-- hide if condition is not true -->
    <div v-else></div>
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script>
export default {
  props: ["input", "block"],
  computed: {
    providesCondition() {
      if (!this.input.showIf) {
        return false;
      }
      const currentValue = this.block.config[this.input.showIf.property];
      const targetValue = this.input.showIf.targetValue;
      if (currentValue === targetValue) {
        return true;
      }
      return false;
    },
  },
};
</script>